import React from "react";
import PropTypes from "prop-types";
import { Card, Box, CircularProgress } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import VerticalBarChart2 from "examples/Charts/BarCharts/VerticalBarChart/index2";

const PerformanceChartCard = ({ index, chartData, title, t }) => {
  const isLoading = !chartData;

  const renderChart = () => {
    if (isLoading) {
      return (
        <Box display="flex" justifyContent="center" p={1}>
          <CircularProgress size={20} />
        </Box>
      );
    }

    if (index === 1) {
      return (
        <Box width="100%" maxWidth="100%" overflow="auto">
          <VerticalBarChart2 height={300} chart={chartData} />
        </Box>
      );
    }

    if (index === 2) {
      return (
        <Box width="100%" maxWidth="100%" overflow="auto">
          <VerticalBarChart
            chart={chartData}
            width="100%"
            height={200}
            xAxisTitle={t("user.dashboards.resultPercentage")}
            yAxisTitle={t("user.dashboards.numberOfEmployees")}
          />
        </Box>
      );
    }

    return null;
  };

  return (
    <MDBox py={index === 2 ? 1 : 0} px={1} width="100%">
      <MDBox mb={1} width="100%">
        <MDTypography
          variant={index === 2 ? "h6" : "h5"}
          align={index === 2 ? "center" : "left"}
          fontSize={index === 2 ? "14px" : undefined}
          fontWeight={index === 1 ? "medium" : undefined}
        >
          {title}
        </MDTypography>
      </MDBox>

      <MDBox
        flexGrow={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        sx={{ overflowX: "auto" }}
        mt={index === 1 ? 0 : 0}
      >
        {renderChart()}
      </MDBox>
    </MDBox>
  );
};

PerformanceChartCard.propTypes = {
  index: PropTypes.oneOf([1, 2]).isRequired,
  chartData: PropTypes.object,
  title: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default PerformanceChartCard;
